import React from "react";
import PropTypes from "prop-types";
import NeoButton from "../../../../../components/Common/NeoButton";
import NeoTable from "../../../../../components/Common/NeoTable";
import NeoCard from "../../../../../components/Common/NeoCard";

const DetailSupport = ({ chamados, setChamados, handleLogAction }) => {
    // Colunas da NeoTable para Chamados (compactadas)
    const chamadosColumns = [
        {
            key: "id",
            label: "Chamado / Status",
            width: "20%",
            render: (row) => (
                <div>
                    <span className="fw-bold text-secondary d-block">#00{row.id}</span>
                    <span className={`badge ${row.status === "Aberto" ? "bg-primary" : "bg-success"} rounded d-inline-block mt-0.5`}>
                        {row.status}
                    </span>
                </div>
            )
        },
        {
            key: "title",
            label: "Assunto / Categoria",
            width: "40%",
            render: (row) => (
                <div>
                    <div className="fw-semibold text-dark text-truncate" style={{ maxWidth: "250px" }} title={row.title}>{row.title}</div>
                    <span className="text-xs text-muted d-block">{row.category}</span>
                </div>
            )
        },
        {
            key: "priority",
            label: "Prioridade / Abertura",
            width: "25%",
            render: (row) => (
                <div>
                    <span className={`badge ${row.priority === "Alta" ? "bg-danger" : "bg-warning"} text-white rounded d-inline-block`}>
                        {row.priority}
                    </span>
                    <span className="text-xs text-muted d-block mt-0.5">{new Date(row.date).toLocaleDateString("pt-BR")}</span>
                </div>
            )
        },
        {
            key: "actions",
            label: "Ações",
            width: "15%",
            align: "center",
            render: (row) => (
                <div className="d-flex justify-content-center">
                    {row.status === "Aberto" && (
                        <NeoButton
                            variant="soft-success"
                            size="sm"
                            square
                            onClick={() => {
                                setChamados(chamados.map(c => c.id === row.id ? { ...c, status: "Resolvido" } : c));
                                handleLogAction("support_ticket_resolved", `Chamado #00${row.id} marcado como Resolvido`);
                            }}
                            title="Resolver Chamado"
                            icon="mdi-check-all"
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <NeoCard
            title="Histórico de Chamados e Suporte"
            subtitle="Gerenciamento de chamados abertos e resolvidos"
            headerActions={
                <NeoButton variant="primary" size="sm" onClick={() => {
                    const newTicket = {
                        id: chamados.length + 1,
                        title: "Solicitação de novo template de certificado",
                        category: "Suporte",
                        priority: "Média",
                        status: "Aberto",
                        date: new Date().toISOString().split("T")[0]
                    };
                    setChamados([newTicket, ...chamados]);
                    handleLogAction("support_ticket_created", "Abriu novo chamado interno de suporte para a academia");
                }}>
                    <i className="ph-light ph-plus me-1" /> Registrar Chamado
                </NeoButton>
            }
            thinBorder={true}
            bodyClassName="p-0"
        >
            <NeoTable
                columns={chamadosColumns}
                data={chamados}
                emptyMessage="Nenhum chamado de suporte registrado"
            />
        </NeoCard>
    );
};

DetailSupport.propTypes = {
    chamados: PropTypes.array.isRequired,
    setChamados: PropTypes.func.isRequired,
    handleLogAction: PropTypes.func.isRequired
};

export default DetailSupport;
